import React from "react";
import { connect } from "react-redux";
import ContentEditable from "react-contenteditable";
import { Col, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { deepClone, toCamelCase } from "../../../../helpers/objectHelper";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import { defaultInvoiceElement } from "../../../models/defaultElements";
import { conditionActions } from "../../../../store/actions/cms/condition.action";
import { labelAlignment } from "../../../helpers/labelAlignment";
import { securityHelper } from "../../../../helpers/securityHelper";
import { CountryList } from "../../../../system/CountryList/CountryList";
import { invoiceFieldValidator } from "./invoiceFieldValidator";
import IsRequiredSymbol from "../../../../components/UI/Form/IsRequiredSymbol";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";
import JirangoCheckbox2 from "../../../../components/UI/Checkbox/JirangoCheckbox2";

class PaymentOptions extends React.Component {
  state = {
    showInvoiceFields: true,
    showPaymentOptions: true,
    notSelectedMessage: 'YouNeedToSelectAPaymentOption',
    notSelected: false

  };
  componentDidMount() {
    const { element, dispatch } = this.props;
    if (
      element &&
      element.data &&
      element.data.paymentMethods &&
      element.data.paymentMethods.length === 1 &&
      element.data.paymentMethods.includes("invoice")
    ) {
      this.addInvoiceFields();
      dispatch(attendeeActions.setPayMethod("invoice"));
    } else if (
      element &&
      element.data &&
      element.data.paymentMethods &&
      element.data.paymentMethods.length === 1 &&
      element.data.paymentMethods.includes("dibs")
    ) {
      dispatch(attendeeActions.setPayMethod("dibs"));
    }
    if (
      this.props.getValidator &&
      typeof this.props.getValidator === "function"
    ) {
      console.log('payment validator')
      this.props.updateValidator(this.updateValidator);
    }
  }
  componentDidUpdate() {
    const { element } = this.props;
    if (
      element &&
      element.data &&
      element.data.paymentMethods &&
      element.data.paymentMethods.length === 1 &&
      element.data.paymentMethods.includes("invoice")
    ) {
      this.addInvoiceFields();
    }
  }
  componentWillUnmount() {
    if (
      this.props.updateValidator &&
      typeof this.props.updateValidator === "function"
    ) {
      console.log('will umount')
      this.props.updateValidator(this.updateValidator, true);
    }
  }
  addFieldProps = type => {
    switch (type) {
      case "Name":
        return true;
      case "Address1":
        return true;
      case "Address2":
        return false;
      case "Zip":
        return true;
      case "City":
        return true;
      case "OrgNo":
        return true;
      case "GLN":
        return false;
      case "Email":
        return false;
      case "CountryCode":
        return true;
      case "Telephone1":
        return false;
      default:
        return false;
    }
  };
  updateValidator = () => {
    if (
      this.props.getValidator &&
      typeof this.props.getValidator === "function"
    ) {
      this.props.getValidator(() => this.validationReq());
    }
  }
  validationReq = () => {
    const invoiceFields = this.props.form.formElements
      .filter(el => el.type == elementConstants.INVOICE_FIELD);
    let allValid = true;
    if (!this.props.attendee.payMethod && this.checkIfOrderHasValue() > 0) {
      allValid = false; this.setState({ notSelected: true })
    }
    else if (this.props.attendee.payMethod === 'invoice' && this.checkIfOrderHasValue() > 0) {
      invoiceFields.map(iv => {
        let isValid = invoiceFieldValidator(
          this.getFieldValue(iv),
          iv.props.name,
          iv.data
        );
        if (isValid === false) {
          allValid = false;
        }
        if (iv.isValid !== isValid) {
          let newElement = deepClone(iv);
          newElement.isValid = isValid;
          this.handleUpdate(newElement);
        }
      })
    }
    return allValid;
  }
  checkIfOrderHasValue = () => {
    const { attendee } = this.props;
    let value = 0;
    if (attendee.orders && attendee.orders.length > 0) {
      attendee.orders.map(o => {
        if (o.orderRow && o.orderRow.length > 0) {
          o.orderRow.map(or => {
            value += or.amount;

          })
        }
      })
    }
    if (value === NaN) value = 0;
    return value;
  }
  addInvoiceFields = () => {
    const missingInvoiceFields = [
      "Name",
      "OrgNo",
      "GLN",
      "Telephone1",
      "Address1",
      "Address2",
      "Zip",
      "City",
      "CountryCode",
      "Email",
    ];
    const { form } = this.props;
    let sortOrder = 0;
    let currentFields = form.formElements.filter(
      el => el.type == elementConstants.INVOICE_FIELD
    );
    if (currentFields && currentFields.length > 0) {
      currentFields.map(cf => {
        let index = missingInvoiceFields.indexOf(cf.data.name);
        if (index >= 0) {
          missingInvoiceFields.splice(index, 1);
        }
      });
      sortOrder = currentFields.length + 1;
    }
    if (missingInvoiceFields.length > 0) {
      let newElementList = [];
      missingInvoiceFields.map(mif => {
        let newElement = deepClone(defaultInvoiceElement);

        newElement.eventId = this.props.form.eventId;
        newElement.formId = this.props.form.formId;
        newElement.languageCode = this.props.form.languageCode;
        newElement.contentId = securityHelper.createGuid();
        newElement.sortOrder = sortOrder++;
        newElement.data.name = mif;
        newElement.isValid = undefined;
        newElement.data.required = this.addFieldProps(mif);
        newElementList.push(newElement);
      });
      let newForm = deepClone(form);
      newForm.formElements = Array.from(form.formElements).concat(
        newElementList
      );
      newForm.formElements.map(el => {
        if (el.type == elementConstants.INVOICE_FIELD) {
          el.props = {
            name: el.data.name,
            type: el.data.type,
            length: el.data.length,
            labels: el.data.labels,
            text: el.props.text || ""
          };
        }
      });
      this.props.dispatch(formActions.softUpdate(newForm, true));
    } else {
      let newForm = deepClone(form);
      let updated = false;
      newForm.formElements = Array.from(form.formElements);
      newForm.formElements.map(el => {
        if (el.type == elementConstants.INVOICE_FIELD) {
          if (
            !el.props ||
            (el.props &&
              (el.props.name !== el.data.name ||
                el.props.type != el.data.type ||
                el.props.length != el.data.length ||
                el.props.labels != el.data.labels))
          ) {
            el.props = {
              name: el.data.name,
              type: el.data.type,
              length: el.data.length,
              labels: el.data.labels,
              text: (el.props && el.props.text) || ""
            };
            updated = true;
          }
        }
      });
      if (updated) {
        this.props.dispatch(formActions.softUpdate(newForm, true));
      }
    }
  };
  forceValidate = element => {
    const { form } = this.props;
    const countryCodeField = form.formElements.find(el => {
      return (
        el.type == elementConstants.INVOICE_FIELD &&
        el.props.name === "CountryCode"
      );
    });
    let countryCode = null;
    if (countryCodeField) {
      countryCode = this.getFieldValue(countryCodeField);
    }
    if (countryCode && countryCode.length !== 3) {
      countryCode = null;
    }
    if (!element) {
      let currentFields = form.formElements.filter(
        el => el.type == elementConstants.INVOICE_FIELD
      );
      if (currentFields.length > 0) {
        let isValid = true;
        currentFields.map(el => {
          if (
            !invoiceFieldValidator(
              this.getFieldValue(el),
              el.data.name,
              el.data,
              countryCode
            )
          )
            isValid = false;
        });
        return isValid;
      } else {
        return true;
      }
    } else {
      return invoiceFieldValidator(
        this.getFieldValue(element),
        element.props.type,
        element.data,
        countryCode
      );
    }
  };
  removeInvoiceFields = () => {
    const { form } = this.props;
    let currentFields = form.formElements.filter(
      el => el.type == elementConstants.INVOICE_FIELD
    );
    if (currentFields.length > 0) {
      let newForm = deepClone(form);
      newForm.formElements = form.formElements.filter(
        el => el.type !== elementConstants.INVOICE_FIELD
      );
      this.props.dispatch(formActions.softUpdate(newForm, true));
    }
  };
  handleChange(e, element, path) {
    const names = path.split(".");
    const newElement = deepClone(element);
    newElement[names[0]][names[1]] = e.target.value;
  
    this.handleUpdate(newElement);
  }
  handleValueChange = (value, element) => {
    const { attendee, dispatch } = this.props;
    if (attendee && attendee.orders) {
      let order = attendee.orders[attendee.activePersonNo];
      let newOrder = deepClone(order);
      let type = newOrder[toCamelCase(element.props.type)];
      let newType = undefined;
      if (!type) {
        newType = {};
      } else {
        newType = deepClone(type);
      }
      newType[toCamelCase(element.props.name)] = value;
      newOrder[toCamelCase(element.props.type)] = newType;
      console.log("payment", order.orderRow, order, attendee.activePersonNo);
      dispatch(attendeeActions.updateOrder(newOrder, attendee.activePersonNo));
    }
    let isValid = invoiceFieldValidator(
      value,
      element.props.name,
      element.data
    );
    if (isValid !== element.isValid) {
      let newElement = deepClone(element);
      newElement.isValid = isValid;
      this.handleUpdate(newElement);
    }
  };
  getFieldValue = element => {
    const { attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      let type = order[toCamelCase(element.props.type)];
      if (type) {
        let val = type[toCamelCase(element.props.name)];
        if (val) {
          return val;
        }
      }
    }
    return "";
  };
  handleSelectOnChange = (o, path, el) => {
    const names = path.split(".");
    const element = deepClone(el);
    if (names[1] === "text") {
      element[names[0]][names[1]] = o.value;
      element.isValid = invoiceFieldValidator(
        o.value,
        element.props.name,
        element.data
      );
    }
    this.handleValueChange(o.value, element)
    this.handleUpdate(element);
  };
  handleUpdate = element => {
    const { dispatch, cms } = this.props;
    element.forceValidationMessage = false;
    dispatch(formActions.updateFormElement(element));
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
  };
  renderField = (element, index) => {
    const { cms, attendee } = this.props;
    const { template } = this.props.template;
    const parentElement = this.props.element;
    if (!element.props) {
      const { labels, name, type, length } = element.data;
      element.props = { ...element.props, labels, name, type, length };
    }

    let isRequired = this.addFieldProps(element.props.name);
    let fieldLabel = element.props.labels.find(l => {
      return (
        l.languageCode === this.props.form.languageCode &&
        l.text &&
        l.text.length > 0
      );
    });
    return (
      <React.Fragment key={index}>
        <FormGroup>
          <Row
            style={{
              flexDirection: labelAlignment(parentElement.data.labelAlign),
              margin: "0px"
            }}
            className="responsive-row"
          >
            <Col
              className="qs-label-col"
              style={{
                maxWidth:
                  parentElement.data.labelAlign !== "center" &&
                  parentElement.data.titleWidth !== undefined &&
                  parentElement.data.titleWidth + "%",
                wordBreak:
                  parentElement.data.labelAlign !== "center" && "break-word",
                padding: "0px"
              }}
            >
              <div style={{ display: "inline-flex", width: "100%" }}>
                {fieldLabel && element.props.name === "Name" ? (
                  <ContentEditable
                    style={
                      template
                        ? {
                          ...template.content.label,
                          marginRight: "10px",
                          wordBreak: "break-word"
                        }
                        : {
                          wordBreak: "break-word"
                        }
                    }
                    innerRef={this.contentEditable}
                    html={fieldLabel.text}
                    onChange={e => this.handleChange(e, "props.labels")}
                    tagName="label"
                  />
                ) : (
                    <Label
                      style={
                        template
                          ? {
                            ...template.content.label,
                            marginRight: "10px",
                            wordBreak: "break-word"
                          }
                          : {
                            wordBreak: "break-word"
                          }
                      }
                    >
                      <SystemLabel
                        groupName={"Form.Edit"}
                        languageCode={this.props.form.languageCode || "swe"}
                        name={"Invoice" + element.props.name}
                      ></SystemLabel>
                    </Label>
                  )}
                <IsRequiredSymbol condition={isRequired} />
              </div>
            </Col>
            <Col
              className="responsive-input-slot"
              style={{
                maxWidth:
                  parentElement.data.labelAlign !== "center" &&
                  parentElement.data.inputWidth !== undefined &&
                  parentElement.data.inputWidth + "%",
                padding: "0px"
              }}
            >
              {element.props.name === "CountryCode" ? (
                <React.Fragment>
                  <CountryList
                    onChange={this.handleSelectOnChange}
                    isReadOnly={element.data.readOnly}
                    value={this.getFieldValue(element)}
                    template={template}
                    languageCode={this.props.form.languageCode}
                    element={element}
                    width={parentElement.data.style.width}
                  />
                  <Input
                    autoComplete="jirango-nofill"
                    style={{ display: "none" }}
                    valid={element.isValid === true}
                    invalid={element.isValid === false}
                  />
                  <FormFeedback valid={element.isValid === true}>
                    {element.isValid === false ? (
                      <SystemLabel
                        groupName={"Form.Edit"}
                        languageCode={this.props.form.languageCode || "swe"}
                        name={
                          "Invoice" + element.props.name + "ValidationMessage"
                        }
                      />
                    ) : null}
                  </FormFeedback>
                </React.Fragment>
              ) : (
                  <React.Fragment>
                    <Input
                      autoComplete="jirango-nofill"
                      type={"text"}
                      className="responsive-input"
                      onChange={e =>
                        this.handleValueChange(e.target.value, element)
                      }
                      autoComplete="off"
                      autoFocus={false}
                      readOnly={element.data.readOnly || false}
                      required={element.data.required || false}
                      value={this.getFieldValue(element)}
                      style={
                        template &&
                        template.content && {
                          ...template.content.input,
                          width: "unset",
                          width: parentElement.data.style.width,
                          wordBreak: "break-word"
                        }
                      }
                      maxLength={element.data.maxCharacters}
                      valid={element.isValid === true}
                      invalid={element.isValid === false}
                    />
                    <FormFeedback valid={element.isValid == true}>
                      {element.isValid === false ? (
                        <SystemLabel
                          groupName={"Form.Edit"}
                          languageCode={this.props.form.languageCode || "swe"}
                          name={
                            "Invoice" + element.props.name + "ValidationMessage"
                          }
                        />
                      ) : (
                          ""
                        )}
                    </FormFeedback>
                  </React.Fragment>
                )}
            </Col>
          </Row>
        </FormGroup>
      </React.Fragment>
    );
  };
  selectPayMethod = method => {
    const { attendee, dispatch } = this.props;
    if (attendee && attendee.orders) {
      dispatch(attendeeActions.setPayMethod(method));
    }
    if (method === "invoice") {
      this.addInvoiceFields();
    } else {
      this.removeInvoiceFields();
    }
    this.setState({ notSelected: false })
  };
  getPayMethod = () => {
    const { attendee } = this.props;
    if (attendee && attendee.payMethod) {
      return attendee.payMethod;
    }
    return "";
  };
  handleSoftUpdate = element => {
    const { dispatch, cms } = this.props;
    const { enviroment } = cms;

    dispatch(formActions.updateFormElement(element));

  };
  checkAdapter = (value, method) => {
    this.selectPayMethod(method)
  }

  renderRadioButtons = () => {
    const { template } = this.props.template;
    let element = this.props.element;
    let selectedPayMethod = this.getPayMethod();
    return (
      <React.Fragment>
        <Row>
          <Col style={{ paddingLeft: '30px' }}>
            <Input
              style={{ display: 'none' }}
              valid={this.state.notSelected === false}
              invalid={this.state.notSelected === true}
            />
            <FormFeedback valid={this.state.notSelected === false}>
              {this.state.notSelected === true ? (
                <SystemLabel
                  groupName={"Form.Edit"}
                  languageCode={this.props.form.languageCode || "swe"}
                  name={
                    'SelectPaymentMethod'
                  }
                />
              ) : (
                  ""
                )}
            </FormFeedback>
          </Col>
        </Row>

        <div>
          {element &&
            element.data &&
            element.data.paymentMethods &&
            element.data.paymentMethods.includes("dibs") ? (
              <JirangoCheckbox2
                editable={false}
                labelName={"DibsPaymentOption"}
                textStyle={{
                  ...template.content.text
                }}
                systemLabel={true}
                boxStyle={{
                  ...template.content.button
                }}
                checkboxIsDisabled={false
                }
                languageCode={this.props.form.languageCode || 'swe'}
                isReadonly={element.data.readOnly}
                labelPlacement={'end'}
                labelOnchange={this.handleChange}
                id={"dibs"}
                boxType={'radio'}
                optionSpacing={'0px'}
                checkOnchange={this.checkAdapter}
                isSelected={(this.props.attendee.payMethod === 'dibs' || this.props.element.data.selectedPayMethod === 'dibs')} />
            ) : null}
          {element &&
            element.data &&
            element.data.paymentMethods &&
            element.data.paymentMethods.includes("invoice") ? (
              <JirangoCheckbox2
                systemLabel={true}
                editable={false}
                labelName={"InvoicePaymentOption"}
                textStyle={{
                  ...template.content.text
                }}
                boxStyle={{
                  ...template.content.button
                }}
                checkboxIsDisabled={false
                }
                optionSpacing={'0px'}
                isReadonly={element.data.readOnly}
                labelPlacement={'end'}
                labelOnchange={this.handleChange}
                languageCode={this.props.form.languageCode || 'swe'}
                id={"invoice"}
                boxType={'radio'}
                checkOnchange={this.checkAdapter}
                isSelected={(this.props.attendee.payMethod === 'invoice' || this.props.element.data.selectedPayMethod === 'invoice')} />
              /*    <JirangoCheckbox
                   onChange={e => this.selectPayMethod(`invoice`)}
                   inline={true}
                   value={selectedPayMethod === "invoice"}
                   type="radio"
                   boxType="radio"
                   labelName={"InvoicePaymentOption"}
                 /> */
            ) : null}
        </div>

      </React.Fragment>
    );
  };
  render() {
    const { form, cms, element, attendee } = this.props;
    const { template } = this.props.template;
    const invoiceFields = form.formElements
      .filter(el => el.type == elementConstants.INVOICE_FIELD)
      .sort((a, b) => a.sortOrder - b.sortOrder);
    if (!cms.editMode && this.checkIfOrderHasValue() === 0 || this.checkIfOrderHasValue() === undefined) return null;
    return (
      <React.Fragment>
        {cms.editMode && element &&
          element.data &&
          element.data.paymentMethods &&
          element.data.paymentMethods.length === 0 ? (
            <Row style={{
              margin: "0px", width: "100%",
              background: 'rgb(213, 234, 247)',
              padding: '25px 0px',
              borderRadius: '6px' //FÖr JAn
            }}>
              {" "}
              <div style={{
                display: 'inline-block',
                position: 'relative',
                width: '200px',
                height: '200px',
                overflow: 'hidden',
                borderRadius: '50%',

                margin: '0 auto 0.5rem auto'
              }}>
                <img src="https://i.pinimg.com/originals/4f/73/04/4f730422d664b00ea08f63be8132232e.gif"
                  style={{ margin: 'auto', width: '100%', height: 'auto' }} />
              </div><br />
              <Label style={{
                margin: 'auto',
                width: '100%', textAlign: 'center',
                fontSize: '18px', position: 'absolute',
                top: '73%',
                color: 'rgb(76, 91, 120)',
                fontFamily: 'Arimo',
                fontWeight: 'bold'
              }}><SystemLabel name="SelectPaymentMethod" /></Label>
              <p style={{
                margin: 'auto',
                width: '100%', textAlign: 'center',
                fontSize: '14px', position: 'absolute',
                top: '84%',
                color: 'rgb(76, 91, 120)',
                fontFamily: 'Arimo',
                fontStyle: 'italic'
              }}><SystemLabel name="OnlyVisibleInEditMode" /></p>
            </Row>
          ) : null}
        {cms.editMode && element &&
          element.data &&
          element.data.paymentMethods &&
          (element.data.paymentMethods.length === 1 &&
            element.data.paymentMethods.includes("dibs")) ? (
            <Row style={{
              margin: "0px", width: "100%",
              background: '#fff',
              paddingBottom: '25px',
              borderRadius: '6px' //FÖr JAn
            }}>
              {" "}
              <img src="https://blog.reepay.com/wp-content/uploads/2017/04/DIBS.png"
                style={{ margin: 'auto', maxWidth: '100%', maxHeight: '150px' }} />
              <p style={{
                margin: 'auto',
                width: '100%', textAlign: 'center',
                fontSize: '14px', position: 'absolute',
                top: '84%',
                color: 'rgb(76, 91, 120)',
                fontFamily: 'Arimo',
                fontStyle: 'italic'
              }}><SystemLabel name="OnlyVisibleInEditMode" /></p>
            </Row>
          ) : null}

        {element &&
          element.data &&
          element.data.paymentMethods &&
          element.data.paymentMethods.length > 1 ? (
            <Row style={{ marginBottom: (element.data.selectedPaymentMethod === "invoice" || attendee.payMethod === 'invoice') ? '24px' : 'unset' }}>
              <Col>
                {/* <FormGroup style={{ marginBottom: '0rem' }}> */}{this.renderRadioButtons()}{/* </FormGroup> */}
              </Col>
            </Row>
          ) : null}
        {/*    {element &&
          element.data &&
          element.data.paymentMethods &&
          ((element.data.paymentMethods.length > 1 &&
            element.data.paymentMethods.includes("invoice")) &&
            element.data.paymentMethods.includes("dibs")) &&
        (  attendee.payMethod === 'dibs' || element.data.selectedPayMethod === 'dibs') &&
          invoiceFields.length > 0 ? (
            <Row
              style={{
                padding: element.data.padding + "px",
                width: "100%",
                margin: "0px"
              }}
            >
              <Col style={{ padding: "0px" }}>
                {invoiceFields.map(this.renderField)}
              </Col>
            </Row>
          ) : null} */}

        {element &&
          element.data &&
          element.data.paymentMethods &&
          ((element.data.paymentMethods.length === 1 &&
            element.data.paymentMethods.includes("invoice")) ||
            (element.data.selectedPaymentMethod === "invoice" || attendee.payMethod === 'invoice')) &&
          invoiceFields.length > 0 ? (
            <Row
              style={{
                padding: element.data.padding + "px",
                width: "100%",
                margin: "0px"
              }}
            >
              <Col style={{ padding: "0px" }}>
                {invoiceFields.map(this.renderField)}
              </Col>
            </Row>
          ) : null}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template,
    cms: state.cms,
    attendee: state.attendee
  };
}

export default connect(mapStateToProps)(PaymentOptions);
